import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

import { IQBRAttachmentForDownload } from '../models'

export const fetchAllDocumentAttachments = async (
  documentId: number
): Promise<IQBRAttachmentForDownload[]> => {
  const url = proxy('/webservice/197/sp/v4/spJBPQBRAttachmentList/call')

  const {
    app: { ownerId },
  } = appGetState()
  const [accessToken] = getTokens(ownerId)

  const payload = {
    'p.DocumentId': documentId,
  }

  const headers = new HttpHeaders()

  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }
  const response = await Rest.post({ url, payload, headers })
  if (response && response.Data) {
    return response.Data
  }

  return []
}
